export default "__VITE_ASSET__Bi4W1rl4__"